// extracted by mini-css-extract-plugin
export default {"container":"thread-item-separator_container__VYBi+"};